import type { SurroundingProducts } from 'services/productsApi';
import ProductNavigationLink from 'components/Collection/pages/product/ProductNavigation/ProductNavigationLink';

type ProductNavigationProps = {
  products: SurroundingProducts;
};

export const ProductNavigation = ({ products }: ProductNavigationProps) => (
  <div className="container">
    <div className="row">
      <div className="col-span-6 sm:col-span-5">
        {products.previous && <ProductNavigationLink product={products.previous} direction="previous" />}
      </div>

      <div className="col-span-6 sm:col-span-5 sm:col-start-8">
        {products.next && <ProductNavigationLink product={products.next} direction="next" />}
      </div>
    </div>
  </div>
);

export default ProductNavigation;
